export const RoleValidationView: React.FC<{
  uploadedData: any[];
  businessAreas: FP.Entities.IBusinessArea[];
  processedEntities: Record<string, any[]>;
  onComplete: (result: FP.Entities.IRole[]) => void;
}> = ({ uploadedData, businessAreas, processedEntities, onComplete }) => {
  return <div>Role validation</div>;
};
